<div class="bubble-tabs mt-0">
	<a class="bubble-tab" routerLink="control" routerLinkActive="selected">Control Bucket</a>
	<a class="bubble-tab" routerLink="failed" routerLinkActive="selected">Failed Imports</a>
	<a class="bubble-tab" routerLink="xml/acex" routerLinkActive="selected">ACEX</a>
	<a class="bubble-tab" routerLink="xml/acop" routerLinkActive="selected">ACOP</a>
	<a class="bubble-tab" routerLink="xml/acstate" routerLinkActive="selected">ACSTATE</a>
	<a class="bubble-tab" routerLink="xml/ci" routerLinkActive="selected">CI</a>
	<a class="bubble-tab" routerLink="xml/cycnt" routerLinkActive="selected">CYCNT</a>
	<a class="bubble-tab" routerLink="xml/evnt" routerLinkActive="selected">EVNT</a>
	<a class="bubble-tab" routerLink="xml/log" routerLinkActive="selected">LOG</a>
	<a class="bubble-tab" routerLink="xml/obcustat" routerLinkActive="selected">OBCUSTAT</a>
	<a class="bubble-tab" routerLink="xml/param" routerLinkActive="selected">PARAM</a>
	<a class="bubble-tab" routerLink="xml/pcs" routerLinkActive="selected">PCS</a>
	<a class="bubble-tab" routerLink="xml/raw" routerLinkActive="selected">RAW</a>
	<a class="bubble-tab" routerLink="xml/tach" routerLinkActive="selected">TACH</a>
</div>
<router-outlet></router-outlet>